import { PhotoSwipeLightbox } from "vendor";

const CLOSE_SVG = `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
  <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
  <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
  <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
</svg>`;

let sharedLightbox = null;

function getMaxZoom() {
  const pg = document.querySelector("product-gallery[allow-zoom]");
  if (pg) {
    const level = parseInt(pg.getAttribute("allow-zoom"), 10);
    if (!Number.isNaN(level)) return level;
  }
  return 3;
}

function getLightbox() {
  if (sharedLightbox) return sharedLightbox;
  const strings = window.themeVariables?.strings || {};
  sharedLightbox = new PhotoSwipeLightbox({
    pswpModule: () => import("photoswipe"),
    bgOpacity: 1,
    maxZoomLevel: getMaxZoom(),
    closeTitle: strings.closeGallery || "Close",
    zoomTitle: strings.zoomGallery || "Zoom",
    errorMsg: strings.errorGallery || "Error",
    arrowPrev: false,
    arrowNext: false,
    counter: false,
    zoom: false,
    closeSVG: CLOSE_SVG
  });
  sharedLightbox.addFilter("thumbEl", (thumbEl, data) => data["thumbnailElement"]);
  sharedLightbox.init();
  return sharedLightbox;
}

function openNutritionLightbox(img) {
  const lb = getLightbox();
  const dataSource = [{
    thumbnailElement: img,
    src: img.src,
    srcset: img.srcset || "",
    msrc: img.currentSrc || img.src,
    width: parseInt(img.getAttribute("width"), 10) || img.naturalWidth || img.width,
    height: parseInt(img.getAttribute("height"), 10) || img.naturalHeight || img.height,
    alt: img.alt || "",
    thumbCropped: true
  }];
  lb.loadAndOpen(0, dataSource);
}

function wireNutritionZoom(root) {
  const scope = root && root.querySelector ? root : document;
  scope.querySelectorAll(".bk-media-nutrition-gallery").forEach((gallery) => {
    gallery.querySelectorAll(".bk-media-nutrition-gallery__media").forEach((media) => {
      if (media.dataset.bkNutritionZoomWired === "true") return;
      media.dataset.bkNutritionZoomWired = "true";
      const img = media.querySelector(".bk-media-nutrition-gallery__image");
      if (!img) return;
      media.addEventListener("click", (e) => {
        e.preventDefault();
        openNutritionLightbox(img);
      });
    });
  });
}

function wireNaehrwerteTabs(root) {
  const scope = root && root.querySelector ? root : document;
  scope.querySelectorAll("[data-bk-naehrwerte-root][data-bk-naehrwerte-tabs]").forEach((container) => {
    if (container.dataset.bkNaehrwerteTabsWired === "true") return;
    container.dataset.bkNaehrwerteTabsWired = "true";
    const tabs = container.querySelectorAll("[data-bk-naehrwerte-tab]");
    const panels = container.querySelectorAll("[data-bk-naehrwerte-panel]");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const target = tab.getAttribute("data-bk-naehrwerte-tab");
        tabs.forEach((t) => {
          const on = t.getAttribute("data-bk-naehrwerte-tab") === target;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", String(on));
        });
        panels.forEach((p) => {
          p.classList.toggle("is-active", p.getAttribute("data-bk-naehrwerte-panel") === target);
        });
      });
    });
  });
}

function initBkMediaNutrition(root) {
  wireNaehrwerteTabs(root);
  wireNutritionZoom(root);
}

document.addEventListener("DOMContentLoaded", () => initBkMediaNutrition(document));
document.addEventListener("shopify:section:load", (e) => {
  if (e.target) initBkMediaNutrition(e.target);
});
document.addEventListener("product:rerender", () => {
  setTimeout(() => initBkMediaNutrition(document), 100);
});
